import moment from "moment";

import "moment/locale/pt-br";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCircle,
    faChartBar,
    faHashtag,
} from "@fortawesome/free-solid-svg-icons";

import Table from "../../../../Components/Table";
import ModalComponent from "../../../../Components/Modais";

import {
    IAtendimentoClienteRequest,
    TModoGestaoAtendimento,
} from "../../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";

import {
    ExportarExcelAtendimentosClienteController,
    ListarAtendimentosParaTransferirController,
} from "../../../../Controllers/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoControllers";
import { ACESSOS } from "../../../../Routes/Acessos";
import ExportExcel from "../../../../Components/StickyToolbar/ExportExcel";
import TransferirTodosAtendimento from "../../../../Components/CardsPages/Atendimento/TransferirTodosAtendimentos";
import "./styles.css";
import FiltroAtendimentos from "./FiltroAtendimentos";
import useAtendimento from "./useAtendimento";
import ElementosTableAtendimentoCliente from "./FiltroAtendimentos/elementosTable";
import FiltroAtendimentoOrdenacao from "./FiltroAtendimentosOrdernacao/FiltroAtendimentoOrdenacao";
// import { Switch } from "../../../../Components/CardsPages/Forms/Switch";

// interface IPropsTableChange extends TableChangeState<any> {
//     searchText: string;
// }

interface IFilterFormDataInterface {
    DT_INICIAL_IN?: string;
    DT_INICIAL_FN?: string;
    DT_EXPECTATIVA_CONCLUSAO_IN?: string;
    DT_EXPECTATIVA_CONCLUSAO_FN?: string;
    DT_SLA_IN?: string;
    DT_SLA_FN?: string;
    DT_ULTIMA_INTERACAO_IN?: string;
    DT_ULTIMA_INTERACAO_FN?: string;
    DT_FINAL_IN?: string;
    DT_FINAL_FN?: string;
    ORDER_BY?: string;
    VL_DESC_ASC?: string;
    DT_REAL_CONCLUSAO?: string;
    DS_STATUS_CASO?: string;
    ID_MOTIVO_CANCELAMENTO?: number;
    ID_EMPREENDIMENTO?: string | number;
    ID_UNIDADE?: number;
    ID_CASO?: number;
    FL_ANDAMENTO?: number;
    FL_CONTEM?: boolean;
    PESQUISA?: string;
    ID_USUARIO?: number;
    DS_NOME_CONTA?: string;
    DS_NOME_CONTATO?: string;
    ID_CATEGORIA_ATENDIMENTO?: number[];
    ID_SUBCATEGORIA?: number;
    ID_CONTA: number;
    ID_ACOMPANHAMENTO?: number;
    ID_ETAPA_CATEGORIA_ATENDIMENTO?: string[] /* array de arrays 'stringados' - ['8', '12,15,37', '38, 99'] */;
    ID_TIPOS_PESOS_ATENDIMENTOS?: number[];
    ID_TIPO_CANAL_ATENDIMENTO?: 0;
}

interface IAtendimentosAoClienteProps {
    atendimento: TModoGestaoAtendimento;
}

function AtendimentosAoCliente(props: IAtendimentosAoClienteProps) {
    moment.locale("pt-br");

    const {
        watchStatusCaso,
        limparFiltros,
        idEmpreendimento,
        setIdEmpreendimento,
        idTipoPeso,
        setIdTipoPeso,
        categoriaAtendimento,
        setCategoriaAtendimento,
        options,
        valueEtapa,
        setValueEtapa,
        valueSubCategoria,
        setValueSubCategoria,
        selectInputRef,
        tipoRef,
        customStyles,
        subCategoriasOptions,
        etapasOptions,
        lstTipoPesoOptions,
        listarCanalAtendimento,
        valueEmpreendimentos,
        setValueEmpreendimentos,
        setFilter,
        show,
        setShow,
        modal,
        setModal,
        listarClientes,
        updateList,
        filter,
        FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE,
        filtroInicial,
        setPage,
        totalPaginas,
        listarClientesLoading,
        lstUsuarios,
        filtroOrdenacao,
        atendentesOptions,
        setValueAtendente,
        valueAtendente,
    } = useAtendimento(props.atendimento);

    const { atendimentoColumns, tableviewColumns } =
        ElementosTableAtendimentoCliente(
            props.atendimento,
            setShow,
            setModal,
            updateList,
            filter
        );

    const handleDateChange = (formData: IFilterFormDataInterface) => {
        const filterFormData: IAtendimentoClienteRequest = {
            ...formData,
            ID_CONTA: 0,
            DT_FINAL_IN:
                formData.DT_FINAL_IN && formData.DT_FINAL_IN?.length > 0
                    ? formData.DT_FINAL_IN
                    : undefined,
            DT_FINAL_FN:
                formData.DT_FINAL_FN && formData.DT_FINAL_FN?.length > 0
                    ? formData.DT_FINAL_FN
                    : undefined,
            DT_INICIAL_IN:
                formData.DT_INICIAL_IN && formData.DT_INICIAL_IN?.length > 0
                    ? formData.DT_INICIAL_IN
                    : undefined,
            DT_INICIAL_FN:
                formData.DT_INICIAL_FN && formData.DT_INICIAL_FN?.length > 0
                    ? formData.DT_INICIAL_FN
                    : undefined,
            DT_EXPECTATIVA_CONCLUSAO_IN:
                formData.DT_EXPECTATIVA_CONCLUSAO_IN &&
                formData.DT_EXPECTATIVA_CONCLUSAO_IN?.length > 0
                    ? formData.DT_EXPECTATIVA_CONCLUSAO_IN
                    : undefined,
            DT_EXPECTATIVA_CONCLUSAO_FN:
                formData.DT_EXPECTATIVA_CONCLUSAO_FN &&
                formData.DT_EXPECTATIVA_CONCLUSAO_FN?.length > 0
                    ? formData.DT_EXPECTATIVA_CONCLUSAO_FN
                    : undefined,
            DT_ULTIMA_INTERACAO_IN:
                formData.DT_ULTIMA_INTERACAO_IN &&
                formData.DT_ULTIMA_INTERACAO_IN?.length > 0
                    ? formData.DT_ULTIMA_INTERACAO_IN
                    : undefined,
            DT_ULTIMA_INTERACAO_FN:
                formData.DT_ULTIMA_INTERACAO_FN &&
                formData.DT_ULTIMA_INTERACAO_FN?.length > 0
                    ? formData.DT_ULTIMA_INTERACAO_FN
                    : undefined,
            DT_SLA_IN:
                formData.DT_SLA_IN && formData.DT_SLA_IN?.length > 0
                    ? formData.DT_SLA_IN
                    : undefined,
            DT_SLA_FN:
                formData.DT_SLA_FN && formData.DT_SLA_FN?.length > 0
                    ? formData.DT_SLA_FN
                    : undefined,

            DS_NOME_CONTA:
                formData.DS_NOME_CONTA && formData.DS_NOME_CONTA?.length > 0
                    ? formData.DS_NOME_CONTA
                    : undefined,
            DS_NOME_CONTATO:
                formData.DS_NOME_CONTATO && formData.DS_NOME_CONTATO?.length > 0
                    ? formData.DS_NOME_CONTATO
                    : undefined,
            DS_STATUS_CASO:
                formData.DS_STATUS_CASO && formData.DS_STATUS_CASO?.length > 0
                    ? formData.DS_STATUS_CASO
                    : undefined,
            ID_MOTIVO_CANCELAMENTO:
                formData.ID_MOTIVO_CANCELAMENTO &&
                formData.ID_MOTIVO_CANCELAMENTO > 0
                    ? formData.ID_MOTIVO_CANCELAMENTO
                    : 0,
            ID_CASO:
                formData.ID_CASO && !isNaN(formData.ID_CASO)
                    ? formData.ID_CASO
                    : undefined,
            ID_CATEGORIA_ATENDIMENTO: categoriaAtendimento ?? [],
            ID_SUBCATEGORIA: valueSubCategoria
                ? valueEtapa?.flatMap?.((e) => e.value)
                : undefined,
            ID_EMPREENDIMENTO: idEmpreendimento ?? [],
            FL_ANDAMENTO: formData.FL_ANDAMENTO ?? 0,
            ID_USUARIO:
                valueAtendente && valueAtendente?.value > 0
                    ? valueAtendente?.value
                    : undefined,
            ID_ACOMPANHAMENTO:
                formData.ID_ACOMPANHAMENTO && formData.ID_ACOMPANHAMENTO > 0
                    ? formData.ID_ACOMPANHAMENTO
                    : 0,
            ID_TIPOS_PESOS_ATENDIMENTOS: idTipoPeso ?? [],
            ID_TIPO_CANAL_ATENDIMENTO:
                formData.ID_TIPO_CANAL_ATENDIMENTO &&
                formData.ID_TIPO_CANAL_ATENDIMENTO > 0
                    ? formData.ID_TIPO_CANAL_ATENDIMENTO
                    : 0,
            FL_CONTEM: Boolean(formData.FL_CONTEM),
            VL_DESC_ASC:
                filter?.VL_DESC_ASC === true || filter?.VL_DESC_ASC === false
                    ? filter?.VL_DESC_ASC
                    : undefined,
            ORDER_BY: filter?.ORDER_BY ?? undefined,
        };

        setFilter(filterFormData);
        sessionStorage.setItem(
            `FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE_${props.atendimento}`,
            JSON.stringify(filterFormData)
        );
    };

    const handleDateChangeOrder = (formData: IFilterFormDataInterface) => {
        const filterFormData: IAtendimentoClienteRequest = {
            ...filter,
            ...formData,
            ID_CONTA: 0,
            DT_FINAL_IN:
                filter?.DT_FINAL_IN && filter?.DT_FINAL_IN?.length > 0
                    ? filter?.DT_FINAL_IN
                    : undefined,
            DT_FINAL_FN:
                filter?.DT_FINAL_FN && filter?.DT_FINAL_FN?.length > 0
                    ? filter?.DT_FINAL_FN
                    : undefined,
            DT_INICIAL_IN:
                filter?.DT_INICIAL_IN && filter?.DT_INICIAL_IN?.length > 0
                    ? filter?.DT_INICIAL_IN
                    : undefined,
            DT_INICIAL_FN:
                filter?.DT_INICIAL_FN && filter?.DT_INICIAL_FN?.length > 0
                    ? filter?.DT_INICIAL_FN
                    : undefined,
            DT_EXPECTATIVA_CONCLUSAO_IN:
                filter?.DT_EXPECTATIVA_CONCLUSAO_IN &&
                filter?.DT_EXPECTATIVA_CONCLUSAO_IN?.length > 0
                    ? filter?.DT_EXPECTATIVA_CONCLUSAO_IN
                    : undefined,
            DT_EXPECTATIVA_CONCLUSAO_FN:
                filter?.DT_EXPECTATIVA_CONCLUSAO_FN &&
                filter?.DT_EXPECTATIVA_CONCLUSAO_FN?.length > 0
                    ? filter?.DT_EXPECTATIVA_CONCLUSAO_FN
                    : undefined,
            DT_ULTIMA_INTERACAO_IN:
                filter?.DT_ULTIMA_INTERACAO_IN &&
                filter?.DT_ULTIMA_INTERACAO_IN?.length > 0
                    ? filter?.DT_ULTIMA_INTERACAO_IN
                    : undefined,
            DT_ULTIMA_INTERACAO_FN:
                filter?.DT_ULTIMA_INTERACAO_FN &&
                filter?.DT_ULTIMA_INTERACAO_FN?.length > 0
                    ? filter?.DT_ULTIMA_INTERACAO_FN
                    : undefined,
            DT_SLA_IN:
                filter?.DT_SLA_IN && filter?.DT_SLA_IN?.length > 0
                    ? filter?.DT_SLA_IN
                    : undefined,
            DT_SLA_FN:
                filter?.DT_SLA_FN && filter?.DT_SLA_FN?.length > 0
                    ? filter?.DT_SLA_FN
                    : undefined,

            DS_NOME_CONTA:
                filter?.DS_NOME_CONTA && filter?.DS_NOME_CONTA?.length > 0
                    ? filter?.DS_NOME_CONTA
                    : undefined,
            DS_NOME_CONTATO:
                filter?.DS_NOME_CONTATO && filter?.DS_NOME_CONTATO?.length > 0
                    ? filter?.DS_NOME_CONTATO
                    : undefined,
            DS_STATUS_CASO:
                filter?.DS_STATUS_CASO && filter?.DS_STATUS_CASO?.length > 0
                    ? filter?.DS_STATUS_CASO
                    : undefined,
            ID_MOTIVO_CANCELAMENTO:
                filter?.ID_MOTIVO_CANCELAMENTO &&
                filter?.ID_MOTIVO_CANCELAMENTO > 0
                    ? filter?.ID_MOTIVO_CANCELAMENTO
                    : 0,
            ID_CASO:
                filter?.ID_CASO && !isNaN(filter?.ID_CASO)
                    ? filter?.ID_CASO
                    : undefined,
            ID_CATEGORIA_ATENDIMENTO: categoriaAtendimento ?? [],
            ID_SUBCATEGORIA: valueSubCategoria
                ? valueEtapa?.flatMap?.((e) => e.value)
                : undefined,
            ID_EMPREENDIMENTO: idEmpreendimento ?? [],
            FL_ANDAMENTO: filter?.FL_ANDAMENTO ?? 0,
            ID_USUARIO:
                valueAtendente && valueAtendente?.value > 0
                    ? valueAtendente?.value
                    : undefined,
            ID_ACOMPANHAMENTO:
                filter?.ID_ACOMPANHAMENTO && filter?.ID_ACOMPANHAMENTO > 0
                    ? filter?.ID_ACOMPANHAMENTO
                    : 0,
            ID_TIPOS_PESOS_ATENDIMENTOS: idTipoPeso ?? [],
            ID_TIPO_CANAL_ATENDIMENTO:
                filter?.ID_TIPO_CANAL_ATENDIMENTO &&
                filter?.ID_TIPO_CANAL_ATENDIMENTO > 0
                    ? filter?.ID_TIPO_CANAL_ATENDIMENTO
                    : 0,
            FL_CONTEM: Boolean(filter?.FL_CONTEM),
            ORDER_BY: formData?.ORDER_BY ?? undefined,
            VL_DESC_ASC:
                formData?.VL_DESC_ASC === "true"
                    ? true
                    : formData?.VL_DESC_ASC === "false"
                    ? false
                    : undefined,
        };

        setFilter(filterFormData);
        sessionStorage.setItem(
            `FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE_${props.atendimento}`,
            JSON.stringify(filterFormData)
        );
    };

    return (
        <div className="card card-custom">
            {listarClientesLoading ? (
                <></>
            ) : (
                <div className="d-flex flex-row px-4 pt-4 justify-content-around">
                    <div className="px-4 pt-1 pb-2 bg-primary rounded text-white">
                        <div className="d-flex align-items-center">
                            <span className="svg-icon svg-icon-2x">
                                <FontAwesomeIcon icon={faChartBar} />
                            </span>
                            <span className="card-title font-weight-bolder text-white-75 font-size-h2 text-center mt-1 mb-2 ml-2">
                                {listarClientes?.NR_CASOS ?? 0}
                            </span>
                        </div>
                        <span className="font-weight-bold font-size-sm">
                            Total de Atendimentos
                        </span>
                    </div>
                    <div className="px-4 pt-1 pb-2 bg-info rounded text-white">
                        <div className="d-flex align-items-center">
                            <span className="svg-icon svg-icon-2x">
                                <FontAwesomeIcon icon={faCircle} />
                            </span>
                            <span className="card-title font-weight-bolder text-white-75 font-size-h2 text-center mt-1 mb-2 ml-2">
                                {listarClientes?.NR_CASOS_EM_DIA ?? 0}
                            </span>
                        </div>
                        <span className="font-weight-bold font-size-sm">
                            Atendimento no Prazo
                        </span>
                    </div>
                    <div className="px-4 pt-1 pb-2 bg-danger rounded text-white">
                        <div className="d-flex align-items-center">
                            <span className="svg-icon svg-icon-2x">
                                <FontAwesomeIcon icon={faHashtag} />
                            </span>
                            <span className="card-title font-weight-bolder text-white-75 font-size-h2 text-center mt-1 mb-2 ml-2">
                                {listarClientes?.NR_CASOS_EM_ATRASO ?? 0}
                            </span>
                        </div>
                        <span className="font-weight-bold font-size-sm">
                            Atendimento Atrasados
                        </span>
                    </div>
                </div>
            )}
            <div className="card-body mt-n2 table-responsive">
                <Table
                    columns={atendimentoColumns}
                    data={listarClientes?.ATENDIMENTOS ?? []}
                    keyField="ID_CASO"
                    onTableChange={(type, newState) => {
                        setPage(newState.page);
                    }}
                    tableView={{
                        columns: tableviewColumns,
                        noSort: true,
                        sizePerPage: 10,
                        cancelYScroll: true,
                        defaultStyle: true,
                    }}
                    remote={{ pagination: true }}
                    totalPages={totalPaginas}
                    loading={listarClientesLoading}
                    noDataIndication={() => (
                        <div className="text-black-50 text-center">
                            Nenhum Atendimento encontrado
                        </div>
                    )}
                    noHover
                    noSearch
                    bordered={false}
                />
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />

            <FiltroAtendimentos
                atendimento={props.atendimento}
                filter={filter}
                FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE={
                    FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE
                }
                categoriaAtendimento={categoriaAtendimento}
                customStyles={customStyles}
                etapasOptions={etapasOptions}
                lstTipoPesoOptions={lstTipoPesoOptions}
                options={options}
                selectInputRef={selectInputRef}
                setCategoriaAtendimento={setCategoriaAtendimento}
                setIdEmpreendimento={setIdEmpreendimento}
                setIdTipoPeso={setIdTipoPeso}
                setValueEtapa={setValueEtapa}
                filtroInicial={filtroInicial}
                subCategoriasOptions={subCategoriasOptions}
                tipoRef={tipoRef}
                valueEmpreendimentos={valueEmpreendimentos}
                setValueEmpreendimentos={setValueEmpreendimentos}
                valueEtapa={valueEtapa}
                valueSubCategoria={valueSubCategoria}
                limparFiltros={limparFiltros}
                listarCanalAtendimento={listarCanalAtendimento}
                setPage={setPage}
                setValueSubCategoria={setValueSubCategoria}
                watchStatusCaso={watchStatusCaso}
                tipoAtendimento={props.atendimento}
                lstUsuarios={lstUsuarios}
                handleDateChange={handleDateChange}
                atendentesOptions={atendentesOptions}
                setValueAtendente={setValueAtendente}
                valueAtendente={valueAtendente}
            />
            <FiltroAtendimentoOrdenacao
                FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE={
                    FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE
                }
                atendimento={props.atendimento}
                filter={filter}
                setFilter={setFilter}
                watchStatusCaso={watchStatusCaso}
                filtroOrdenacao={filtroOrdenacao}
                tipoAtendimento={props.atendimento}
                handleDateChange={handleDateChangeOrder}
                filtroInicial={filtroInicial}
            />

            <ExportExcel
                baixarExcelController={async () =>
                    ExportarExcelAtendimentosClienteController(
                        filter ? filter : filtroInicial,
                        0,
                        props.atendimento
                    )
                }
                nomeArquivo={"Atendimento_Cliente"}
            />
            <TransferirTodosAtendimento
                ID_TIPO_CASO={ACESSOS.ATENDIMENTO.ID_MODULO}
                filter={filter}
                setShow={setShow}
                update={() => {
                    updateList(filter, 1, props.atendimento);
                }}
                controller={() =>
                    ListarAtendimentosParaTransferirController(
                        filter ? filter : filtroInicial,
                        0,
                        props.atendimento
                    )
                }
            />
        </div>
    );
}

export default AtendimentosAoCliente;
